module.exports = __webpack_public_path__ + "c221331d9830e5f921c2efdbfbf360bb.svg";